<template>
  <SHeading color="primary" level="2" size="2">{{ title }}</SHeading>
  <div class="homepage-popular-products">
    <NuxtLink
      v-for="product in products"
      :key="product.id"
      class="homepage-popular-products__card"
      :to="product.href"
    >
      <img
        v-if="product.image"
        :alt="product.name"
        class="homepage-popular-products__card-image"
        :src="product.image"
      />
      <div class="homepage-popular-products__card-content">
        <p class="homepage-popular-products__card-title">
          {{ product.name }}
        </p>
        <p
          v-if="product.description"
          class="homepage-popular-products__card-description"
        >
          {{ product.description }}
        </p>
        <div class="homepage-popular-products__card-link">
          {{ tr("client.products.about_vertical", { title: product.name }) }}
          <span
            class="fas fa-arrow-right homepage-popular-products__card-link-icon"
          />
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";

import { SHeading } from "@solvari/components";
import { useI18nClient } from "@solvari/translations";

type PopularProduct = {
  description: string | null;
  href: string;
  id: string;
  image: string | null;
  name: string;
};

defineProps<{
  products: PopularProduct[];
  title: string;
}>();

const { tr } = useI18nClient();
</script>

<style lang="postcss">
.homepage-popular-products {
  @apply grid gap-8 grid-cols-auto-80 grid-cols-auto-grow;

  &__card {
    @apply flex flex-col rounded-bl-3xl rounded-tr-3xl border border-gray-300 no-underline;

    &:hover {
      @apply -translate-y-0.5 transform transition-transform;
    }

    &-image {
      @apply h-full max-h-44 min-h-44 w-full rounded-tr-3xl object-cover;
    }

    &-content {
      @apply mx-6 flex flex-1 flex-col pb-8 pt-6;
    }

    &-title {
      @apply mb-2 text-lg font-semibold text-gray-900;
    }

    &-description {
      @apply text-gray-700;
    }

    &-link {
      @apply mt-auto flex items-center pt-2 text-primary-700;

      &-icon {
        @apply ml-2 text-primary-700;
      }

      &:hover {
        @apply text-primary-500;

        .homepage-popular-products__card-link-icon {
          @apply text-primary-500;
        }
      }
    }
  }
}
</style>
